import ApprovalStateTypes from '@/febos/global/documentManagement/mixins/ApprovalStateTypes';
import PublicationStateTypes from '@/febos/global/documentManagement/mixins/PublicationStateTypes';
import ValidityStateTypes from '@/febos/global/documentManagement/mixins/ValidityStateTypes';

export default {
  methods: {
    fileTypeIcon(file) {
      if (file.type === 'folder') return {};
      const { mime } = file;
      const extension = file.name.split('.').pop().toLowerCase();

      if (typeof mime !== 'undefined') {
        if (mime.includes('image')) return 'file-image';
        if (mime.includes('video')) return 'file-video';
        if (mime.includes('audio')) return 'file-audio';
        if (mime.includes('csv')) return 'file-csv';
        if (mime.includes('plain')) return 'file-alt';
        if (mime.includes('zip') || (file.size && file.size.includes('compress'))) return 'file-archive';
        if (mime.includes('pdf')) return 'file-pdf';
        if (mime.includes('power')) return 'file-powerpoint';
        if (mime.includes('word')) return 'file-word';
        if (mime.includes('excel')) return 'file-excel';
      } else {
        if (['png', 'jpg', 'jpeg', 'gif'].includes(extension)) return 'file-image';
        if (['mp4', 'mpg', 'avi', 'mkv', 'flv', 'mov', 'wmv'].includes(extension)) return 'file-video';
        if (['mp3', 'ogg', 'wav', 'flac', 'aiff', 'wma', 'aac'].includes(extension)) return 'file-audio';
        if (['csv'].includes(extension)) return 'file-csv';
        if (['rtf', 'txt', 'log'].includes(extension)) return 'file-alt';
        if (['zip', 'rar', 'bzip', 'gz'].includes(extension)) return 'file-archive';
        if (['pdf'].includes(extension)) return 'file-pdf';
        if (['ppt', 'pptx', 'pps', 'ppsx'].includes(extension)) return 'file-powerpoint';
        if (['doc', 'docx'].includes(extension)) return 'file-word';
        if (['xls', 'xlsx'].includes(extension)) return 'file-excel';
      }
      return 'file';
    },
    publicationStateIcon(file) {
      // circle - borrador (3) - gray
      // circle - en revision (2) - orange
      // circle - publicado(1) - green
      let color = 'text-grey';
      let message = 'Borrador';
      if (file.publicationState === PublicationStateTypes.PUBLISHED) {
        color = 'text-success';
        message = 'Publicado';
      }
      if (file.publicationState === PublicationStateTypes.MOVING) {
        color = 'text-warning';
        message = 'Procesando';
      }
      if (file.publicationState === PublicationStateTypes.IN_REVIEW) {
        color = 'text-orange';
        message = 'En revisión';
      }
      return {
        icon: 'circle',
        tooltip: `Publicación: ${message}`,
        message,
        classes: {
          [color]: true,
          'mr-1': true
        }
      };
    },
    validityStateIcon(file) {
      // calendar - no aplica (0) - gray
      // calendar-check - vigente(1) - green
      // calendar-times - vencido(3) - red
      let icon = 'calendar';
      let color = 'text-grey';
      let message = 'No aplica';
      if (file.validityState === ValidityStateTypes.VALID) {
        icon = 'calendar-check';
        color = 'text-success';
        message = 'Vigente';
      }
      if (file.validityState === ValidityStateTypes.EXPIRED) {
        icon = 'calendar-times';
        color = 'text-danger';
        message = 'Vencido';
      }
      return {
        icon: `${icon}`,
        tooltip: `${message}`,
        message,
        classes: {
          [color]: true,
          'mr-1': true
        }
      };
    },
    approvalStateIcon(file) {
      // circle - no aplica (0) - gray
      // check-circle - aprobado(?) - green
      // times-circle - rechazado(?) - red
      // user-circle - en aprobación(?) - naranjo
      let icon = 'circle';
      let color = 'text-grey';
      let message = 'No aplica';
      if (file.approvalState === ApprovalStateTypes.APPROVED) {
        icon = 'check-circle';
        color = 'text-success';
        message = 'Aprobado';
      }
      if (file.approvalState === ApprovalStateTypes.REJECTED) {
        icon = 'times-circle';
        color = 'text-danger';
        message = 'Rechazado';
      }
      if (file.approvalState === ApprovalStateTypes.ON_APROBATION) {
        icon = 'user-circle';
        color = 'text-orange';
        message = 'En aprobación';
      }
      return {
        icon: `${icon}`,
        tooltip: `Aprobación: ${message}`,
        message,
        classes: {
          [color]: true,
          'mr-1': true
        }
      };
    }
  }
};
